var _radialGradient, _linearGradient;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAverageInteractionsPerWeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 129,
    viewBox: "0 0 332 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "hceck9oraa",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "myce258iyc",
    x1: 0.5,
    y1: 1.017,
    x2: 0.5,
    y2: -0.606,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c7de1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "029q1rax0b"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2859",
    width: 332,
    height: 129,
    rx: 16,
    transform: "translate(-8523 -11790)",
    style: {
      fill: "url(#hceck9oraa)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Insight Card Inside Graphic",
    transform: "translate(8523 11790)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate",
      clipPath: "url(#029q1rax0b)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2744"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2677",
    transform: "translate(-8213.887 -11730.645)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2712",
    width: 14.889,
    height: 69.645,
    rx: 7.445,
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2713",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V49.9H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(0 19.742)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2714",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v34.781H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8233.741 -11703.226)",
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2715",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v19.426H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(-8233.741 -11687.871)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2679",
    transform: "translate(-8253.59 -11744.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2716",
    width: 14.889,
    height: 83.354,
    rx: 7.445,
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2717",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V54.29H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(0 29.064)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2680",
    transform: "translate(-8273.444 -11744.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2718",
    width: 14.889,
    height: 83.903,
    rx: 7.445,
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2719",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v56.716H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(0 19.742)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2681",
    transform: "translate(-8293.297 -11763)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2720",
    width: 14.889,
    height: 102,
    rx: 7.445,
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2721",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v62.748H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(0 31.806)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2682",
    transform: "translate(-8313.149 -11728.451)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2722",
    width: 14.889,
    height: 67.451,
    rx: 7.445,
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2723",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445V51H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(0 16.452)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2683",
    transform: "translate(-8333 -11703.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2724",
    width: 14.889,
    height: 42.774,
    rx: 7.445,
    style: {
      fill: "#cadbf6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2725",
    d: "M7.445 0a7.445 7.445 0 0 1 7.445 7.445v22.716H0V7.445A7.445 7.445 0 0 1 7.445 0z",
    transform: "translate(0 12.613)",
    style: {
      fill: "url(#myce258iyc)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageInteractionsPerWeek);
export default __webpack_public_path__ + "static/media/average-interactions-per-week.92e486c08eb19cb9445bcd03bf011597.svg";
export { ForwardRef as ReactComponent };